<template>
  <a-modal
    title="正则在线测试"
    :width="600"
    :visible="visible"
    @ok="handleTest"
    @cancel="visible = false"
    :confirmLoading="confirmLoading"
    okText="测试"
  >
    <p>正则表达式：</p>
    <a-input v-model="regex"></a-input>
    <p></p>
    <p>匹配模式：</p>
    <a-radio-group v-model="regType" button-style="solid">
      <a-radio-button value="find"> 查找 </a-radio-button>
      <a-radio-button value="matchers"> 全匹配 </a-radio-button>
    </a-radio-group>
    <p></p>
    <p>测试文本：</p>
    <a-textarea v-model="testStr" rows="8"> </a-textarea>
    <p></p>
    <p>测试结果：</p>
    <div v-if="result">
      <a-tag v-if="result.success" color="green"> 匹配通过 </a-tag>
      <a-tag v-else color="red"> 匹配失败 </a-tag>
      <p v-if="result.result">匹配内容：</p>
      <p v-for="(s, i) in result.result" :key="i"><a-tag>{{ s }}</a-tag></p>
    </div>
  </a-modal>
</template>

<script>
import { postAction } from '@/api/manage'
export default {
  name: 'RegexTest',
  data() {
    return {
      visible: false,
      regex: '',
      testStr: '',
      regType: 'find',
      result: null,
      confirmLoading: false
    }
  },
  created() {},
  methods: {
    show() {
      this.visible = true
    },
    handleTest() {
        this.confirmLoading = true
      postAction('/common/utils/regexTest', { regex: this.regex, testStr: this.testStr, regType: this.regType }).then(
        (res) => {
          this.result = res
          this.confirmLoading = false
        }
      )
    },
  },
}
</script>

<style>
</style>